import type { FC } from 'react';

import * as S from './HowItWorksPopupContent.styled';

interface IPropsHowItWorksPopupContent {
  t: (key: string) => string;
}

export const HowItWorksPopupContent: FC<IPropsHowItWorksPopupContent> = ({ t }) => {
  return (
    <S.HowItWorks>
      <S.HowItWorksDescription>
        <S.DescriptionParagraph>{t('trialMiner.descriptionParagraph1')}</S.DescriptionParagraph>
        <S.DescriptionParagraph>{t('trialMiner.descriptionParagraph2')}</S.DescriptionParagraph>
        <S.DescriptionParagraphBold>
          {t('trialMiner.descriptionParagraph3')}
        </S.DescriptionParagraphBold>
      </S.HowItWorksDescription>
      <S.FAQContentList>
        <S.FAQTittle>{t('trialMiner.faq')}</S.FAQTittle>
        <S.FAQContentListItem>
          <S.FAQContentListItemTitle>{t('trialMiner.whatIsTheTrial')}</S.FAQContentListItemTitle>
          <S.FAQContentListItemDescription>
            {t('trialMiner.whatIsTheTrialDescription')}
          </S.FAQContentListItemDescription>
        </S.FAQContentListItem>
        <S.FAQContentListItem>
          <S.FAQContentListItemTitle>
            {t('trialMiner.whoPaysForTheElectricity')}
          </S.FAQContentListItemTitle>
          <S.FAQContentListItemDescription>
            {t('trialMiner.whoPaysForTheElectricityDescription')}
          </S.FAQContentListItemDescription>
        </S.FAQContentListItem>
        <S.FAQContentListItem>
          <S.FAQContentListItemTitle>{t('trialMiner.howMuchWillIEarn')}</S.FAQContentListItemTitle>
          <S.FAQContentListItemDescription>
            {t('trialMiner.howMuchWillIEarnDescription')}
          </S.FAQContentListItemDescription>
        </S.FAQContentListItem>
        <S.FAQContentListItem>
          <S.FAQContentListItemTitle>{t('trialMiner.whatDoINeedToDo')}</S.FAQContentListItemTitle>
          <S.FAQContentListItemDescription>
            {t('trialMiner.whatDoINeedToDoDescription')}
          </S.FAQContentListItemDescription>
        </S.FAQContentListItem>
        <S.FAQContentListItem>
          <S.FAQContentListItemTitle>{t('trialMiner.andIfIDontLikeIt')}</S.FAQContentListItemTitle>
          <S.FAQContentListItemDescription>
            {t('trialMiner.andIfIDontLikeItDescription')}
          </S.FAQContentListItemDescription>
        </S.FAQContentListItem>
        <S.FAQContentListItem>
          <S.FAQContentListItemTitle>{t('trialMiner.howDoIGetTheMoney')}</S.FAQContentListItemTitle>
          <S.FAQContentListItemDescription>
            {t('trialMiner.howDoIGetTheMoneyDescription')}
          </S.FAQContentListItemDescription>
        </S.FAQContentListItem>
        <S.FAQContentListItem>
          <S.FAQContentListItemTitle>
            {t('trialMiner.howDoIWithdrawFunds')}
          </S.FAQContentListItemTitle>
          <S.FAQContentListItemDescription>
            {t('trialMiner.howDoIWithdrawFundsDescription')}
          </S.FAQContentListItemDescription>
        </S.FAQContentListItem>
        <S.FAQContentListItem>
          <S.FAQContentListItemTitle>
            {t('trialMiner.canIBuySeveralTrials')}
          </S.FAQContentListItemTitle>
          <S.FAQContentListItemDescription>
            {t('trialMiner.canIBuySeveralTrialsDescription')}
          </S.FAQContentListItemDescription>
        </S.FAQContentListItem>
        <S.FAQContentListItem>
          <S.FAQContentListItemTitle>
            {t('trialMiner.canIBuyTrialFromAnotherAccount')}
          </S.FAQContentListItemTitle>
          <S.FAQContentListItemDescription>
            {t('trialMiner.canIBuyTrialFromAnotherAccountDescription')}
          </S.FAQContentListItemDescription>
        </S.FAQContentListItem>
        <S.FAQContentListItem>
          <S.FAQContentListItemTitle>{t('trialMiner.whatIfILikeTrial')}</S.FAQContentListItemTitle>
          <S.FAQContentListItemDescription>
            {t('trialMiner.whatIfILikeTrialDescription')}
          </S.FAQContentListItemDescription>
        </S.FAQContentListItem>
      </S.FAQContentList>
    </S.HowItWorks>
  );
};
